import React from "react";
import { useParams } from "react-router-dom";
import { useContent } from "../contentServices";

import ManageMediaAccess from "../../common/ManageMediaAccess";
import PanelLoadingIndicator from "../../../components/PanelLoadingIndicator";

const ManageContentAccess = () => {
  const { id } = useParams();
  const content = useContent(id);

  if (content.isLoading) {
    return <PanelLoadingIndicator />;
  }

  return <ManageMediaAccess media={content.data} />;
};

export default ManageContentAccess;
